import { render, staticRenderFns } from "./EventListElement.vue?vue&type=template&id=10e82e9e&scoped=true&"
import script from "./EventListElement.vue?vue&type=script&lang=ts&"
export * from "./EventListElement.vue?vue&type=script&lang=ts&"
import style0 from "./EventListElement.vue?vue&type=style&index=0&id=10e82e9e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10e82e9e",
  null
  
)

export default component.exports